"use client";

import { ReactNode } from "react";
import SessionProvider from "./SessionProvider";
import { ToastContainer } from "@/components/ui/Toast";

interface Props {
  children: ReactNode;
}

export default function Providers({ children }: Props) {
  return (
    <SessionProvider>
      <ToastContainer />
      {children}
    </SessionProvider>
  );
}
